{
  "title": "Mind Sliver",
  "source": "Tasha's Cauldron of Everything",
  "levelAndSchool": "Enchantment cantrip",
  "level": 0,
  "castingTime": "1 action",
  "range": "60 feet",
  "components": "V",
  "duration": "1 round",
  "description": [
    "You drive a disorienting spike of psychic energy into the mind of one creature you can see within range. The target must succeed on an Intelligence saving throw or take 1d6 psychic damage and subtract 1d4 from the next saving throw it makes before the end of your next turn.",
    "At Higher Levels. This spell’s damage increases by 1d6 when you reach certain levels: 5th level (2d6), 11th level (3d6), and 17th level (4d6)."
  ],
  "spellLists": ["eldritch-knight", "arcane-trickster", "sorcerer", "warlock", "wizard"]
}
